/** Talent Help Center / FAQ. */
const dictionary = {
  en: {
    heading: "Frequently Asked Questions",
    items: [
      {
        id: "how-to-take-assessment",
        title: "How do I take an assessment?",
        description:
          "Open Assessments from the menu, choose a required test, select your language, and start. Each assessment takes about 15 minutes. Complete all required assessments to unlock the rest of the platform.",
      },
      {
        id: "how-long",
        title: "How long do assessments take?",
        description:
          "Most assessments take around 15 minutes. You can pause only if the test provider allows it. Use a quiet place and a Chrome browser for the best experience.",
      },
      {
        id: "retake",
        title: "Can I retake an assessment?",
        description:
          "Yes. Open the completed assessment and choose Retake. Retaking resets your previous results for that assessment.",
      },
      {
        id: "data-share",
        title: "How do I share my results with a company?",
        description:
          "When a company invites you, you will see the request under Data Share Invites. Review the requested assessments and accept or decline data access.",
      },
      {
        id: "delete-account",
        title: "How do I delete my account?",
        description:
          "To delete your account, go to Help Center or contact us at info@apexteam.ai. Your account will be permanently deleted and you cannot retrieve the data later.",
      },
    ],
  },
  de: {
    heading: "Häufig gestellte Fragen",
    items: [
      {
        id: "how-to-take-assessment",
        title: "Wie führe ich ein Assessment durch?",
        description:
          "Öffnen Sie Assessments im Menü, wählen Sie einen erforderlichen Test, wählen Sie Ihre Sprache und starten Sie. Jedes Assessment dauert etwa 15 Minuten. Schließen Sie alle erforderlichen Assessments ab, um den Rest der Plattform freizuschalten.",
      },
      {
        id: "how-long",
        title: "Wie lange dauern die Assessments?",
        description:
          "Die meisten Assessments dauern rund 15 Minuten. Eine Pause ist nur möglich, wenn der Testanbieter dies zulässt. Nutzen Sie einen ruhigen Ort und den Chrome-Browser für die beste Erfahrung.",
      },
      {
        id: "retake",
        title: "Kann ich ein Assessment wiederholen?",
        description:
          "Ja. Öffnen Sie das abgeschlossene Assessment und wählen Sie Wiederholen. Dadurch werden Ihre bisherigen Ergebnisse für dieses Assessment zurückgesetzt.",
      },
      {
        id: "data-share",
        title: "Wie teile ich meine Ergebnisse mit einem Unternehmen?",
        description:
          "Wenn ein Unternehmen Sie einlädt, sehen Sie die Anfrage unter Datenfreigabe-Einladungen. Prüfen Sie die angeforderten Assessments und akzeptieren oder lehnen Sie den Datenzugriff ab.",
      },
      {
        id: "delete-account",
        title: "Wie lösche ich mein Konto?",
        description:
          "Um Ihr Konto zu löschen, gehen Sie zum Hilfezentrum oder kontaktieren Sie uns unter info@apexteam.ai. Ihr Konto wird dauerhaft gelöscht; die Daten können später nicht wiederhergestellt werden.",
      },
    ],
  },
  "fi": {
    "heading": "Usein kysytyt kysymykset",
    "items": [
      {
        "id": "how-to-take-assessment",
        "title": "Miten teen arvioinnin?",
        "description": "Avaa valikosta Arvioinnit, valitse pakollinen testi, valitse kieli ja aloita. Kunkin arvioinnin kesto on noin 15 minuuttia. Suorita kaikki pakolliset arvioinnit, niin pääset käyttämään alustan muita osia."
      },
      {
        "id": "how-long",
        "title": "Kuinka kauan arvioinnit kestävät?",
        "description": "Useimmat arvioinnit kestävät noin 15 minuuttia. Voit keskeyttää vain, jos testin tarjoaja sallii sen. Parhaan käyttökokemuksen saat, kun teet arvioinnin hiljaisessa paikassa Chrome-selaimella."
      },
      {
        "id": "retake",
        "title": "Voinko tehdä arvioinnin uudelleen?",
        "description": "Kyllä. Avaa suoritettu arviointi ja valitse Tee uudelleen. Uudelleen tekeminen nollaa kyseisen arvioinnin aiemmat tulokset."
      },
      {
        "id": "data-share",
        "title": "Miten jaan tulokseni yrityksen kanssa?",
        "description": "Kun yritys kutsuu sinut, näet pyynnön kohdassa Tietojen jakopyynnöt. Tarkista pyydetyt arvioinnit ja hyväksy tai hylkää tietojen käyttö."
      },
      {
        "id": "delete-account",
        "title": "Miten poistan tilini?",
        "description": "Jos haluat poistaa tilisi, siirry Ohjekeskukseen tai ota yhteyttä osoitteeseen info@apexteam.ai. Tilisi poistetaan pysyvästi, etkä voi palauttaa tietoja myöhemmin."
      }
    ]
  }
};

export default dictionary;
